<template>
	<div class="field" :class="{ split: split, right: right, left: left }">
		<label for="fieldName">
			<slot name="label">{{ label }}</slot>
		</label>
		<slot><div class="warning">Add a control Here</div></slot>
	</div>
</template>

<script lang="ts">
import { defineComponent } from "vue"
export default defineComponent({
	name: "I2FormField",
	components: {},
	props: {
		label: {
			type: String,
			Array,
			required: false,
		},
		i18nName: {
			type: String,
			default: "",
		},
		helpElementName: {
			type: String,
			default: "",
		},
		required: {
			type: Boolean,
			default: false,
		},
		split: {
			type: Boolean,
		},
		right: {
			type: Boolean,
		},
		left: {
			type: Boolean,
		},
	},
})
</script>

<style scoped>
.field {
	display: flex;
	flex-direction: column;
	justify-content: flex-end;
	height: 100%;
	min-height: 80px; /* Ensure minimum height for proper alignment */
}

label {
	/* Label styling with balanced text wrapping */
	word-wrap: break-word;
	line-height: 1.3;
	text-wrap: balance;
	hyphens: auto;

	/* Label positioning - keep at bottom line */
	margin-bottom: 0.5rem;
	width: 100%;
}

/* Container for the input field */
.field > :not(label) {
	/* Input field stays at bottom */
	width: 100%;
}

/* Ensure the text-wrap property is supported with vendor prefixes if needed */
@supports (text-wrap: balance) {
	label {
		text-wrap: balance;
	}
}
</style>
